import { render } from "./VendorDetail.vue?vue&type=template&id=0856f7da"
import script from "./VendorDetail.vue?vue&type=script&lang=js"
export * from "./VendorDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__